import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { Button, Flex, Heading, Stack } from '@stepstone-genesis/components';
import { ContentHeading } from '../../../components/common/ContentHeading/index.js';
import { Trans, useTranslation } from '@stepstone-platform/i18n';
import { ArrowLeftIcon } from '@stepstone-genesis/icons';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks.js';
import { emailSelector, refreshResetPasswordState, } from '../resetPasswordSlice.js';
import { navigateToThunk } from '../../../redux/core/navigation/navigationSlice.js';
import { FORM_TYPES } from '../../../types/paramsConfig.js';
import { EnvelopeDocumentPictogram } from '../../../components/common/EnvelopeDocumentPictogram/EnvelopeDocumentPictogram.js';
import { isBrowserSelector } from '../../../redux/core/siteConfig/siteConfigSlice.js';
import { useTrack } from '../../../tracking/common/hooks/useTrack.js';
export const ResetPasswordSuccess = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { value } = useAppSelector(emailSelector);
    const isBrowser = useAppSelector(isBrowserSelector);
    const { trackBtnClick, trackModalComponentVisible } = useTrack('resetPassword');
    useEffect(() => {
        trackModalComponentVisible();
    }, []);
    const onBackToLoginClick = () => {
        trackBtnClick({ uniqueName: 'backToLogin' });
        dispatch(refreshResetPasswordState(false));
        dispatch(navigateToThunk(FORM_TYPES.LOGIN));
    };
    return (_jsxs(Stack, { direction: ['vertical'], spacing: ['spaceS'], flxItems: 'center', sx: { 'white-space': 'pre-line', textAlign: 'center' }, "data-testid": "reset-password-success", children: [_jsx(EnvelopeDocumentPictogram, {}), _jsx(ContentHeading, { label: t('loginregistration.resetPassword.success.header') }), _jsx(Heading, { py: ['spaceS'], variant: 'heading4', fontWeight: 'fontWeightNormal', children: _jsx(Trans, { i18nKey: 'loginregistration.resetPassword.success.body', values: { email: value } }) }), isBrowser && (_jsx(Flex, { flxJustify: 'center', children: _jsx(Button, { a11yLabel: "Back to login button", variant: "link", onClick: onBackToLoginClick, isLoading: false, iconBefore: _jsx(ArrowLeftIcon, {}), children: t('loginregistration.resetPassword.linkButtonLabel') }) }))] }));
};
//# sourceMappingURL=ResetPasswordSuccess.js.map